// src/pages/SettingsOffline.tsx
import { useEffect, useState } from "react";
import {
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Chip,
} from "@mui/material";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useNavigate } from "react-router-dom";
import {
  getDownloadedPrefixes,
} from "@/offline/offlineMeta";
import { useOfflineDownloadStore } from "@/offline/offlineDownloadStore";

export default function SettingsOffline() {
  const [downloaded, setDownloaded] = useState<string[]>([]);
  const jobs = useOfflineDownloadStore((s) => s.jobs);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    getDownloadedPrefixes().then((p) => {
      if (mounted) setDownloaded(p);
    });
    return () => {
      mounted = false;
    };
  }, []);

  // Update downloaded prefixes count when job statuses change (e.g., after a download completes).
  useEffect(() => {
    let mounted = true;
    getDownloadedPrefixes().then((p) => {
      if (mounted) setDownloaded(p);
    });
    return () => {
      mounted = false;
    };
  }, [jobs]);

  const enabled = downloaded.length > 0;
  const hasActiveDownload = Object.values(jobs).some((j) =>
    ["queued", "starting", "downloading", "cancelling"].includes(j.status)
  );
  const hasActiveDelete = Object.values(jobs).some((j) => j.status === "deleting");

  const secondary = hasActiveDelete
    ? "Deleting offline data…"
    : hasActiveDownload
    ? "Downloading prefixes…"
    : enabled
    ? `Enabled • ${downloaded.length} prefix${downloaded.length === 1 ? "" : "es"}`
    : "Off • Download prefixes for offline access";

  return (
    <ListItemButton onClick={() => navigate("/settings/offline")}>
      <ListItemIcon>
        {enabled ? <CloudDownloadIcon color="primary" /> : <CloudOffIcon color="disabled" />}
      </ListItemIcon>
      <ListItemText
        primary="Offline"
        secondary={secondary}
        primaryTypographyProps={{ fontWeight: 600 }}
      />
      {hasActiveDelete ? (
        <Chip label="Deleting" color="warning" size="small" />
      ) : hasActiveDownload ? (
        <Chip label="In progress" color="warning" size="small" />
      ) : enabled ? (
        <Chip label="On" color="primary" size="small" />
      ) : (
        <Chip label="Off" size="small" />
      )}
    </ListItemButton>
  );
}
